import localStorage from 'r/utils/localStorage';
import {READ_MESSAGES as localStorageKey} from '../KEYS';

const stored = JSON.parse(localStorage.getItem(localStorageKey)) || {};

export default class StoredReadMessages {
  static get() {
    return JSON.parse(localStorage.getItem(localStorageKey)) || {};
  }

  static set(value) {
    Object.assign(stored, value);
    localStorage.setItem(localStorageKey, JSON.stringify(stored));
  }
}
